// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__k+jaW","svg":"Loading_svg__j8w0X","gear":"Loading_gear__h2HBQ","watermark":"Loading_watermark__hcm3K"};